import * as React from "react";
import { DocumentTitle } from "components/common";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import WizardPageHeader from "./WizardPageHeader";
import BackendWizard from "../BackendWizard";
import handleCreate from "../HandleCreate";
export const HELP = {
  // server config help
  systemUserDn: /* @__PURE__ */ React.createElement("span", null, "The username for the initial connection to the Active Directory server, e.g. ", /* @__PURE__ */ React.createElement("code", null, "ldapbind@some.domain"), ".", /* @__PURE__ */ React.createElement("br", null), "This needs to match the ", /* @__PURE__ */ React.createElement("code", null, "userPrincipalName"), " of that user."),
  systemUserPassword: "The password for the initial connection to the Active Directory server.",
  // user sync help
  userSearchBase: /* @__PURE__ */ React.createElement("span", null, "The base tree to limit the Active Directory search query to, e.g. ", /* @__PURE__ */ React.createElement("code", null, "cn=users,dc=example,dc=com"), "."),
  userSearchPattern: /* @__PURE__ */ React.createElement("span", null, "For example", " ", /* @__PURE__ */ React.createElement("code", { className: "text-nowrap" }, "(&(objectClass=user)(|(sAMAccountName={0})(userPrincipalName={0})))"), ". The string ", /* @__PURE__ */ React.createElement("code", null, "{0}"), " will be replaced by the entered username."),
  userNameAttribute: /* @__PURE__ */ React.createElement("span", null, "Which Active Directory attribute to use for the full name of the synchronized user, e.g.", " ", /* @__PURE__ */ React.createElement("code", null, "userPrincipalName"), ".", /* @__PURE__ */ React.createElement("br", null), "Try to load a test user in the sidebar section ", /* @__PURE__ */ React.createElement("i", null, "User Login Test"), ", if you are unsure which attribute to use."),
  userFullNameAttribute: /* @__PURE__ */ React.createElement("span", null, "Which Active Directory attribute to use for the full name of a synchronized user, e.g. ", /* @__PURE__ */ React.createElement("code", null, "displayName"), ".", /* @__PURE__ */ React.createElement("br", null)),
  defaultRoles: /* @__PURE__ */ React.createElement("span", null, "The default roles synchronized user will obtain. All users need the ", /* @__PURE__ */ React.createElement("code", null, "Reader"), " role, to use the web interface"),
  defaultUserTimezone: /* @__PURE__ */ React.createElement("span", null, "Choose the default time zone for new users.")
};
export const AUTH_BACKEND_META = {
  serviceTitle: "Active Directory",
  serviceType: "active-directory"
};
const INITIAL_VALUES = {
  title: AUTH_BACKEND_META.serviceTitle,
  serverHost: "localhost",
  serverPort: 636,
  transportSecurity: "tls",
  userSearchPattern: "(&(objectClass=user)(|(sAMAccountName={0})(userPrincipalName={0})))",
  userFullNameAttribute: "displayName",
  userNameAttribute: "userPrincipalName",
  verifyCertificates: true
};
const BackendCreate = () => {
  var _a, _b;
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const {
    help: groupSyncHelp = {},
    excludedFields: groupSyncExcludedFields = {},
    initialValues: initialGroupSyncValues
  } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.activeDirectory) != null ? _b : {};
  const help = { ...HELP, ...groupSyncHelp };
  const initialValues = { ...INITIAL_VALUES, ...initialGroupSyncValues };
  const excludedFields = { ...groupSyncExcludedFields, userUniqueIdAttribute: true, emailAttributes: true };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Create Active Directory Authentication Services" }, /* @__PURE__ */ React.createElement(WizardPageHeader, null), /* @__PURE__ */ React.createElement(
    BackendWizard,
    {
      authBackendMeta: AUTH_BACKEND_META,
      help,
      excludedFields,
      initialValues,
      onSubmit: handleCreate
    }
  ));
};
export default BackendCreate;
